export default __webpack_public_path__ + "static/media/guille.dc4d06dc.jfif";